import { createFileRoute, notFound } from "@tanstack/react-router";

import { GlossaryPage } from "../components/glossary/GlossaryPage";
import { glossaryHead } from "../lib/glossary/head";
import { glossarySlugOf, loadGlossary } from "../lib/glossary/index";
import { GLOSSARY_UI } from "../lib/glossary/ui";
import { documentHeaders } from "../lib/seo";
import { loadToolCopy } from "../lib/tools/index";

/**
 * `/glossary/<slug>`, in English — v1's own address, kept.
 *
 * The tool copy is loaded only when the entry links to one. Eleven of the
 * twenty-one terms have no tool, and those pages should not pull a 30 KB copy
 * bundle to render a sentence saying there is nothing to measure.
 */
export const Route = createFileRoute("/glossary/$slug")({
  loader: async ({ params }) => {
    const slug = glossarySlugOf(params.slug);
    if (!slug) throw notFound();
    const bundle = await loadGlossary("en");
    const toolCopy = bundle[slug].tool ? await loadToolCopy("en") : null;
    return { slug, bundle, toolCopy };
  },
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData
      ? glossaryHead(
          loaderData.slug,
          "en",
          loaderData.bundle[loaderData.slug],
          GLOSSARY_UI.en,
        )
      : {},
  component: EnglishTerm,
});

function EnglishTerm() {
  const { slug, bundle, toolCopy } = Route.useLoaderData();
  return (
    <GlossaryPage
      slug={slug}
      entry={bundle[slug]}
      ui={GLOSSARY_UI.en}
      lang="en"
      bundle={bundle}
      toolCopy={toolCopy}
    />
  );
}
